import api from './api';
import { Bericht, CreateBerichtRequest } from '../types';

export const berichtService = {
  getAll: async (): Promise<Bericht[]> => {
    const response = await api.get('/berichte');
    return response.data;
  },

  getByKundeId: async (kundeId: number): Promise<Bericht[]> => {
    const response = await api.get(`/berichte/kunde/${kundeId}`);
    return response.data;
  },

  getById: async (id: number): Promise<Bericht> => {
    const response = await api.get(`/berichte/${id}`);
    return response.data;
  },

  create: async (data: CreateBerichtRequest): Promise<Bericht> => {
    const response = await api.post('/berichte', data);
    return response.data;
  },

  update: async (id: number, data: CreateBerichtRequest): Promise<Bericht> => {
    const response = await api.put(`/berichte/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/berichte/${id}`);
  },

  markAsGelesen: async (id: number): Promise<void> => {
    await api.put(`/berichte/${id}/gelesen`);
  },

  markAsUngelesen: async (id: number): Promise<void> => {
    await api.delete(`/berichte/${id}/gelesen`);
  },

  markBulkGelesen: async (ids: number[], gelesen: boolean): Promise<void> => {
    await api.put('/berichte/gelesen-bulk', { ids, gelesen });
  },

  updateStatus: async (id: number, statusId: number | null): Promise<void> => {
    await api.put(`/berichte/${id}/status`, { statusId });
  },

  getUngeleseneAnzahl: async (): Promise<number> => {
    const response = await api.get('/berichte/ungelesen-anzahl');
    return response.data.anzahl;
  },

  getOffeneAnzahl: async (): Promise<number> => {
    const response = await api.get('/berichte/offen-anzahl');
    return response.data.anzahl;
  },

  downloadPdf: async (id: number, filename?: string): Promise<void> => {
    const response = await api.get(`/berichte/${id}/pdf`, {
      responseType: 'blob',
    });

    // Extract filename from Content-Disposition header or use fallback
    const contentDisposition = response.headers['content-disposition'];
    let downloadFilename = filename || `Montagebericht_${id}.pdf`;
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=([^;\n]*)/);
      if (filenameMatch && filenameMatch[1]) {
        downloadFilename = filenameMatch[1].replace(/['"]/g, '').trim();
      }
    }

    // Create blob link and trigger download
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = downloadFilename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
};

export default berichtService;
